<template>
  <div class="contact-form">

    <section v-if="successfully_saved" class="contact-form__success">
      <h2 class="contact-form__success-title">Thank you!</h2>
      <p class="contact-form__success-text">We have received your message and will be in touch shortly.</p>
    </section>

    <form v-else class="contact-form__form" @submit.stop.prevent="contactForm__submitted">

      <p class="contact-form__intro">Would you like to provide feedback about your Just Cuts experience? Or perhaps you're looking to chat further with someone from our Team. Please feel free to get in touch today!</p>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">First Name</label>
        <div class="contact-form__field">
          <input class="contact-form__input" type="text" maxlength="50" v-model="contact.first_name" placeholder="First Name" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Last Name</label>
        <div class="contact-form__field">
          <input class="contact-form__input" type="text" maxlength="50" v-model="contact.last_name" placeholder="Last Name" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Email Address</label>
        <div class="contact-form__field">
          <input class="contact-form__input" type="text" maxlength="50" v-model="contact.email" placeholder="Email Address" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Phone</label>
        <div class="contact-form__field">
          <input class="contact-form__input" type="text" maxlength="20" v-model="contact.phone" placeholder="Phone" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Type</label>
        <div class="contact-form__field">
          <select class="contact-form__select" v-model="contact.feedback_type" @change="clearErrors">
            <option value="">Please Select</option>
            <option v-for="option in feedback_types" :key="option" :value="option">{{ option }}</option>
          </select>
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Regarding</label>
        <div class="contact-form__field">
          <select class="contact-form__select" v-model="contact.regarding" @change="clearErrors">
            <option value="">Please Select</option>
            <option v-for="option in regarding_options" :key="option" :value="option">{{ option }}</option>
          </select>
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Relevant Salon</label>
        <div class="contact-form__field">
          <select class="contact-form__select" v-model="contact.salon_id" @change="clearErrors">
            <option :value="null">Please Select</option>
            <option v-for="salon in salons" :key="salon.id" :value="salon.id">{{ salonOptionLabel(salon) }}</option>
          </select>
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Stylist Name</label>
        <div class="contact-form__field">
          <input class="contact-form__input" type="text" maxlength="100" v-model="contact.stylist_name" placeholder="Stylist Name" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="contact-form__row">
        <label class="contact-form__label">Comment (Max 1500 characters)</label>
        <div class="contact-form__field">
          <textarea class="contact-form__textarea" rows="9" maxlength="1500" v-model="contact.comment" @input="clearErrors"></textarea>
          <p class="contact-form__counter">{{ comment_length }} / 1500</p>
        </div>
      </fieldset>

      <fieldset class="contact-form__row contact-form__row--actions">
        <label class="contact-form__label">&nbsp;</label>
        <div class="contact-form__field">
          <button type="submit" class="contact-form__submit" :class="{ 'contact-form__submit--error': error_message.length > 0 }">Submit</button>
          <div class="contact-form__error" v-if="error_message.length > 0">{{ error_message }}</div>
        </div>
      </fieldset>

    </form>
  </div>
</template>


<script>

import Contact from "../../models/Contact";
import Salon from "../../models/Salon";
import Api from "../../services/api";

export default {
  data(){
    return {
      successfully_saved: false,
      contact: Contact.newDefault(),
      salons: [],
      feedback_types: ['Complaint', 'Compliment', 'Other'],
      regarding_options: ['Customer Service', 'Quality of Style Cut', 'Retail Products', 'Wait Time', 'Value for Money', 'WOW Factor', 'Other', 'App'],
      error_message: ""
    }
  },
  async mounted(){
    try {
      this.salons = await Salon.allActiveWithDetails();
    } catch(error){
      console.error("Failed to load salons", error);
    }
  },
  computed:{
    comment_length(){
      return this.contact.comment ? this.contact.comment.length : 0;
    }
  },
  methods:{
    salonOptionLabel(salon){
      const prefix = salon.state_abbreviation ? `${salon.state_abbreviation} - ` : "";
      return `${prefix}${salon.name}`;
    },
    clearErrors(){
      this.error_message = "";
    },
    isFormValid(){
      this.error_message = "";
      if(this.contact.first_name.length < 2){ this.error_message = "Please provide a first name."; }
      else if(this.contact.last_name.length < 2){ this.error_message = "Please provide a last name."; }
      else if(this.contact.email.length < 2){ this.error_message = "Please provide an email address."; }
      else if(this.contact.phone.length < 2){ this.error_message = "Please provide a phone number."; }
      else if(this.contact.feedback_type.length < 1){ this.error_message = "Please select a feedback type."; }
      else if(this.contact.comment.length < 1){ this.error_message = "Please provide a comment."; }
      return this.error_message.length < 1;
    },
    async contactForm__submitted(){
      try {
        if(!this.isFormValid()){
          return;
        }
        await this.contact.create();
        this.successfully_saved = true;
        const match = this.contact.id ? { id: this.contact.id } : { email: this.contact.email };
        Api.sendNotification('contact', match).catch(error => console.error("notification dispatch failed", error));
      } catch(error){
        alert(error.message);
      }
    }
  }
}
</script>
